export const Size = {
  SMALL: 's',
  MEDIUM: 'm',
  LARGE: 'l',
} as const;

export type Size = Union<typeof Size>;
